import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import React from "react";

const SessionTimeout = ({ onCloseDialog, showDialog }) => {
  const { t } = useTranslation();

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-narrow">
        <header className="feedback-modal-header w3-margin-left">
          <h2>{t("session_timeout")}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="modal-close"
            onClick={onCloseDialog}
          />
        </header>
        <div className="w3-container w3-padding-small w3-center w3-margin-bottom">
          <label>{t("please_login_again")}.</label>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeout;
